import React from 'react'
import { NotFound } from 'src/pages/NotFound'
import { ProtectedContainer } from '../ProtectedContainer'

type State = {
  hasError: boolean
  error?: any
}

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(error: any) {
    return { hasError: true, error }
  }

  componentDidCatch(error: any, info: any) {
    console.error('ErrorBoundary:', error, info)
  }

  render() {
    const { hasError, error } = this.state

    if (error?.status === 404) {
      return (
        <ProtectedContainer>
          <NotFound />
        </ProtectedContainer>
      )
    }

    if (hasError) {
      return <h1>Algo deu errado</h1>
    }

    return this.props.children
  }
}
